import React, { useEffect, useState } from 'react';
import * as _ from 'lodash';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DialogList from 'src/dialogs';
import useFetch from 'use-http';
import { ODataOptions, ODataFilter, ODataFilterOperators, /*ODataOrderByDirection*/ } from 'src/util/ODataBuilder';
import ProspectStaff from 'src/models/projectSettings/TsdiProspectStaff';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import TsdiClientInfo from 'src/models/AP/ClientInfo';
import { FaSortAlphaDown, FaSortAlphaUp } from 'react-icons/fa';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import { ITableConfig } from 'src/components/common/table';
import TimeAndExpense from 'src/models/AP/TimeAndExpense';

interface IPersonnelSummaryDialogProps {
    dialogName: string;
    projectId: number;
    client: TsdiClientInfo;
    handleReport?: (category: string, subcategory: string) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    showAddSubcodeDialog?: () => void;
    setAddingAltSubcode?: (addingAltSubcode: boolean) => void;
    setFindingAltSubcode?: (findingAltSubcode: boolean) => void;
    setShowBillingSettings?: (showBillingSettings: boolean) => void;
    timeAndExpenses?: Array<TimeAndExpense>;
}

const PersonnelSummaryDialog = (props: IPersonnelSummaryDialogProps) => {
    const { register, errors, getValues } = useForm();
    const { get, response } = useFetch();
    const [staffingLandmanSearchOptions, setStaffingLandmanSearchOptions] = useState<ODataOptions>(undefined);
    const [staffingLandmen, setStaffingLandmen] = useState<Array<ProspectStaff>>(new Array<ProspectStaff>());
    const [sortDlcNumber, setSortDlcNumber] = useState<boolean>(true);
    const [sortName, setSortName] = useState<boolean>(true);
    const [sortType, setSortType] = useState<boolean>(true);
    const [sortProject, setSortProject] = useState<boolean>(true);
    const [sortDays, setSortDays] = useState<boolean>(true);
    const [sortExpenses, setSortExpenses] = useState<boolean>(true);
    const [sortPayServices, setSortPayServices] = useState<boolean>(true);
    const [sortBillServices, setSortBillServices] = useState<boolean>(true);
    const [writingstaffingLandmen, setWritingstaffingLandmen] = useState<boolean>(true);
    const [staffingLandmanSearchTerm, setStaffingLandmanSearchTerm] = useState<string>('');

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!staffingLandmen) {
            setWritingstaffingLandmen(false);
        }
    }, [staffingLandmen]);

    useEffect(() => {
        if (!!props?.projectId) {
            getStaffingLandmen();
        }
    }, [props?.projectId]);

    useEffect(() => {
        if (!!staffingLandmanSearchOptions) {
            setStaffingLandmanSearchTerm('');
            getStaffingLandmen();
        }
    }, [staffingLandmanSearchOptions]);

    useEffect(() => {
        if ((!!staffingLandmanSearchTerm || staffingLandmanSearchTerm === '') && !!staffingLandmanSearchOptions) {
            resetStaffingLandmanSearchOptions();
        }
    }, [staffingLandmanSearchTerm]);

    const onCreate = () => {
        initializeStaffingLandmanSearchOptions();
    };

    const getStaffingLandmen = async () => {
        const projectId = props?.projectId;
        if (!!staffingLandmanSearchOptions && !!projectId) {
            let queryString = !!staffingLandmanSearchOptions?.toString() ? staffingLandmanSearchOptions?.toString() : '';
            let result = await get(`/v1.0/ClientProjectMaintenance/project/${projectId}/staffing/landmen${queryString}`);

            if (response.ok) {
                setStaffingLandmen(result?.items);
            } else {
                console.log('Unable to get client landmen Data!');
            }
        }
    };

    const initializeStaffingLandmanSearchOptions = () => {
        const tableConfig: ITableConfig = {
            rowCount: 250,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        const options = ODataOptions.from(tableConfig);
        setStaffingLandmanSearchOptions(options);
    };

    const resetStaffingLandmanSearchOptions = () => {
        let newProjectSearchOptions = _.cloneDeep(staffingLandmanSearchOptions);
        newProjectSearchOptions.setIsNextpage(true);
        newProjectSearchOptions.clearFilters();
        newProjectSearchOptions.addPaging(1, 1000);
        const projectId = !!props?.projectId ? props?.projectId : 0;
        if (!projectId) {
            return;
        }
        newProjectSearchOptions.addFilter(new ODataFilter('s.[PR_ID]', ODataFilterOperators.Equals, projectId));
        if (typeof staffingLandmanSearchTerm === 'string') {
            const fieldValues = staffingLandmanSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0])) && fieldValues[0] !== ' ' && fieldValues[0]?.length > 0) {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[UN_NO]', ODataFilterOperators.Equals, !!staffingLandmanSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined && fieldValues[1]?.length > 0 && fieldValues[1] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[UN_NAME]', ODataFilterOperators.Contains, !!staffingLandmanSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined && fieldValues[2]?.length > 0 && fieldValues[2] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('s.[SECTION_TYPE]', ODataFilterOperators.Contains, !!staffingLandmanSearchTerm ? fieldValues[2] : ''));
            }
        }
        setStaffingLandmanSearchOptions(newProjectSearchOptions);
    };

    const onSubmit = () => {
        console.log('OK Clicked');
        let data = getValues();

        props.handleReport(getValues('category'), getValues('subcategory'));
        props.hideDialog();

        console.log(data);
    };

    const displayTitle = () => {
        const title = 'Personnel display options';

        return title;
    };

    const onCancel = () => {
        props.hideDialog();        
    };

    const OKClicked = () => {
        props.hideDialog();
    };

    const displayHeading2 = () => {
        const title = 'Project Staff';

        return title;
    };

    type SortOrder = 'ASC' | 'DESC';

    const sortProspectStaff = <T extends keyof ProspectStaff>(
      array: ProspectStaff[],
      key: T,
      order: SortOrder = 'ASC'
    ): ProspectStaff[] =>
      [...array].sort((a, b): number => {
        const valA = a[key];
        const valB = b[key];
    
        if (valA == null && valB == null) {
            return 0;
        }

        if (valA == null) {
            return order === 'ASC' ? 1 : -1;
        }

        if (valB == null) {
            return order === 'ASC' ? -1 : 1;
        }
    
        return typeof valA === 'string' && typeof valB === 'string'
          ? order === 'ASC'
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA)
          : typeof valA === 'number' && typeof valB === 'number'
          ? order === 'ASC'
            ? valA - valB
            : valB - valA
          : valA instanceof Date && valB instanceof Date
          ? order === 'ASC'
            ? valA.getTime() - valB.getTime()
            : valB.getTime() - valA.getTime()
          : order === 'ASC'
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      });

    const sortByDlcNumber = () => {
        setWritingstaffingLandmen(true);
        setSortDlcNumber(!sortDlcNumber);
        const newState = !sortDlcNumber;
        let newArray = new Array<ProspectStaff>();
        newArray = [...sortProspectStaff(staffingLandmen, 'tsdiEmployeeNumber', !!newState ? 'DESC' : 'ASC')];
        setStaffingLandmen(newArray);
    };
                       
    const sortByName = () => {
        setWritingstaffingLandmen(true);
        setSortName(!sortName);
        const newState = !sortName;
        let newArray = new Array<ProspectStaff>();
        newArray = [...sortProspectStaff(staffingLandmen, 'firstName', !!newState ? 'DESC' : 'ASC')];
        setStaffingLandmen(newArray);
    };

    const sortByType = () => {
        setWritingstaffingLandmen(true);
        setSortType(!sortType);
        const newState = !sortName;
        let newArray = new Array<ProspectStaff>();
        newArray = [...sortProspectStaff(staffingLandmen, 'firstName', !!newState ? 'DESC' : 'ASC')];
        setStaffingLandmen(newArray);
    };

    const sortByProject = () => {
        setWritingstaffingLandmen(true);
        setSortProject(!sortProject);
        const newState = !sortName;
        let newArray = new Array<ProspectStaff>();
        newArray = [...sortProspectStaff(staffingLandmen, 'firstName', !!newState ? 'DESC' : 'ASC')];
        setStaffingLandmen(newArray);
    };

    const sortByDays = () => {
        setWritingstaffingLandmen(true);
        setSortDays(!sortDays);
        const newState = !sortName;
        let newArray = new Array<ProspectStaff>();
        newArray = [...sortProspectStaff(staffingLandmen, 'firstName', !!newState ? 'DESC' : 'ASC')];
        setStaffingLandmen(newArray);
    };

    const sortByExpenses = () => {
        setWritingstaffingLandmen(true);
        setSortExpenses(!sortExpenses);
        const newState = !sortName;
        let newArray = new Array<ProspectStaff>();
        newArray = [...sortProspectStaff(staffingLandmen, 'firstName', !!newState ? 'DESC' : 'ASC')];
        setStaffingLandmen(newArray);
    };

    const sortByPayServices = () => {
        setWritingstaffingLandmen(true);
        setSortPayServices(!sortPayServices);
        const newState = !sortName;
        let newArray = new Array<ProspectStaff>();
        newArray = [...sortProspectStaff(staffingLandmen, 'firstName', !!newState ? 'DESC' : 'ASC')];
        setStaffingLandmen(newArray);
    };

    const sortByBillServices = () => {
        setWritingstaffingLandmen(true);
        setSortBillServices(!sortBillServices);
        const newState = !sortName;
        let newArray = new Array<ProspectStaff>();
        newArray = [...sortProspectStaff(staffingLandmen, 'firstName', !!newState ? 'DESC' : 'ASC')];
        setStaffingLandmen(newArray);
    };

    const displayStaffListSortButtons = () => {
        return (
            <tr>
                <td style={{width: '2.5%', textAlign: 'center'}}>
                    {!sortDlcNumber && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort DLC # Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDlcNumber()}
                    />}
                    {sortDlcNumber && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort DLC # Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDlcNumber()}
                    />}
                </td>
                <td  style={{width: '10%', textAlign: 'center'}}>
                    {!sortName && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Name Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByName()}
                    />}
                    {sortName && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Name Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByName()}
                    />}
                </td>
                <td style={{width: '5%', textAlign: 'center'}}>
                    {!sortType && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort DLC Type Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByType()}
                    />}
                    {sortType && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Type Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByType()}
                    />}
                </td>
                <td style={{width: '10%', textAlign: 'center'}}>
                    {!sortProject && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Project Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByProject()}
                    />}
                    {sortProject && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Project Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByProject()}
                    />}
                </td>
                <td style={{width: '3%', textAlign: 'center'}}>
                    {!sortDays && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Days Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDays()}
                    />}
                    {sortDays && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Days Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDays()}
                    />}
                </td>
                <td style={{width: '3%', textAlign: 'center'}}>
                    {!sortExpenses && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Expenses Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByExpenses()}
                    />}
                    {sortExpenses && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Expenses Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByExpenses()}
                    />}
                </td>
                <td style={{width: '3%', textAlign: 'center'}}>
                    {!sortPayServices && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Pay Services Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByPayServices()}
                    />}
                    {sortPayServices && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Pay Services Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByPayServices()}
                    />}
                </td>
                <td style={{width: '3%', textAlign: 'center'}}>
                    {!sortBillServices && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Bill Services Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByBillServices()}
                    />}
                    {sortBillServices && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Bill Services Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByBillServices()}
                    />}
                </td>
            </tr>
        );
    };

    const displayStaffList = () => {
        return <div>
            <table>
                <thead>                    
                    {displayStaffListSortButtons()}
                    <tr style={{ textAlign: 'left' }}>
                        <th style={{ width: '2.5%' }}>Emp #</th>
                        <th style={{ width: '10%' }}>Name</th>
                        <th style={{ width: '5%' }}>Type</th>
                        <th style={{ width: '10%' }}>Project</th>
                        <th style={{ width: '3%' }}>Days</th>
                        <th style={{ width: '3%' }}>Expenses</th>
                        <th style={{ width: '3%' }}>Pay Services</th>
                        <th style={{ width: '3%' }}>Bill Services</th>
                    </tr>
                </thead>
                <tbody>
                    {!writingstaffingLandmen && !!staffingLandmen && staffingLandmen.length > 0 && staffingLandmen?.map(
                        (ps: ProspectStaff, index: number) => {
                        const tAndE: TimeAndExpense = !!props?.timeAndExpenses ?
                            (props?.timeAndExpenses?.find((te) => te.name === ps.lastName + ',' + ps.firstName)) : undefined;
                        const days: number = !!tAndE ? tAndE?.days : 0;
                        return (
                                <tr key={ps?.id + index} className="table-item-hover" style={{ textAlign: 'center' }}>
                                    <td style={{ width: '2.5%' }}>
                                        <RHFInputBox
                                            name={`landmanTsdNumber`}
                                            type="text"
                                            defaultVal={ps.tsdiEmployeeNumber.toString()}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFInputBox
                                            name={`employeeName`}
                                            type="text"
                                            defaultVal={ps.firstName + ' ' + ps.lastName}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', background: '#d5f7f5' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`type`}
                                            type="text"
                                            defaultVal={!!ps?.payType ? ps?.payType?.toString() : ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFInputBox
                                            name={`project`}
                                            type="text"
                                            defaultVal={!!ps?.endPeriod ? ps?.projectNumber?.toString() : ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{  width: '3%' }}>
                                        <RHFInputBox
                                            name={`days`}
                                            defaultVal={days.toString()}
                                            style={{ width: '40px'}}
                                            register={register}
                                            errors={errors}
                                        />
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        <RHFInputBox
                                            name={`expenses`}
                                            defaultVal={!!ps?.billRate ? ps.billRate.toString() : ''}
                                            style={{ width: '40px'}}
                                            register={register}
                                            errors={errors}
                                        />
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        <RHFInputBox
                                            name={`payServices`}
                                            defaultVal={!!ps?.managerNumber ? ps.managerNumber.toString() : ''}
                                            style={{ width: '40px'}}
                                            register={register}
                                            errors={errors}
                                        />
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        <RHFInputBox
                                            name={`billServices`}
                                            defaultVal={!!ps?.managerNumber ? ps.managerNumber.toString() : ''}
                                            style={{ width: '40px'}}
                                            register={register}
                                            errors={errors}
                                        />
                                    </td>
                                </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>;
    };

    return (
        <>
        <Dialog title="Personnel Summary" dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{ width: '60vw' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form id={`AltSubcodeMaintenanceForm`} onSubmit={onSubmit}>
                <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', padding: '.5rem' }}>
                                        <div className="form-row" style={{display: 'flex', justifyContent: 'center', marginBottom: '0' }}>
                                            <RHFSelect
                                                label={'Display: '}
                                                name={'displayOptions'}
                                                options={[
                                                    {value: 1, label: 'ALL'},
                                                    {value: 1, label: 'Employees'},
                                                    {value: 1, label: 'Contractors'}
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayHeading2()}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                        {displayStaffList()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <div style={{whiteSpace: 'nowrap', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'OK'}
                            onClick={() => OKClicked()}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => onCancel()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
        </>
    );
};

export default PersonnelSummaryDialog;



// WEBPACK FOOTER //
// ./src/components/client-project/dialogs/PersonnelSummaryDialog.tsx